import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';
import { detect } from 'detect-browser';

import OupHeader from '../components/OupHeader/OupHeader';

// import createTitle from '../components/createTitle/createTitle';

import '../styles/main.scss';

const browser = detect();

const TemplateWrapper = ({
  children,
  data: { site: { siteMetadata } },
  location: { pathname },
}) => {
  const langKeyPath = siteMetadata.languages.langs.map(lang => `${withPrefix('/')}${lang.slug}/`);
  const isHomepage = pathname === withPrefix('/') || langKeyPath.some(key => key === pathname);
  // Check if the user is on IE11 or Edge12-15.
  // If so we will add a class to .app and serve some different styles.
  // This is because MS messed up Grid implementation.
  // It is all nice and fixed in Edge 16.
  // Annoyingly we can't feature detect on this.
  // That's because technically these browsers _do_ support grid - just badly.
  const oldIE = () =>
    browser &&
    (browser.name === 'edge' || browser.name === 'ie') &&
    parseInt(browser.version, 10) < 16;

  return (
    <div className="app">
      <Helmet
        title={`${siteMetadata.title} help documents`}
        meta={[
          { name: 'description', content: 'Sample' },
          { name: 'keywords', content: 'sample, something' },
        ]}
      >
        <html className={`${oldIE() ? 'oldIE' : 'modern'}`} />
      </Helmet>
      {/* {isHomepage && <OupHeader />} */}
      {children()}
    </div>
  );
};

TemplateWrapper.propTypes = {
  children: PropTypes.func,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}; // location has other values but they aren't used, so haven't added to PropTypes

export default TemplateWrapper;

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title

        languages {
          langs {
            slug
            title
          }
        }
      }
    }
    sitePage {
      path
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js